var classes = {"tabNavigationHorizontal":"VcjZ0","tabNavigationHorizontalCenter":"uBoKP","underline":"yyQEp","underlineNoTransition":"Xh280"};

export { classes as default };
